/**
 * What a model may be pointed at, in the words the settings pages and the pickers
 * both use. The server holds the same list in ai.js and re-checks every write.
 *
 * `multimodal` is the one that overlaps: a model that reads pictures *and* writes
 * text satisfies a text field and a vision field alike. Almost everything OpenAI
 * and Anthropic publish now is that, and before this existed each row had to pick
 * a side — so models saved for text work were invisible to the photo importer,
 * and re-saving them as vision took them away from the text fields instead.
 */
export const MODALITY_HELP = {
  text: 'Reads and writes text — proofreading, rewriting, extraction.',
  vision: 'Reads an image and returns text — transcription, captions and alt text.',
  multimodal: 'Both: reads images and works on text. Offered wherever either is wanted.',
  image: 'Generates or edits image pixels. Not selectable for text fields.',
  embedding: 'Turns text into vectors for semantic search.',
}

export const MODALITY_TONE = {
  text: 'accent',
  vision: 'info',
  multimodal: 'ok',
  image: 'warn',
  embedding: undefined,
}

export const MODALITIES = ['text', 'vision', 'multimodal', 'image', 'embedding']

/** The three a person actually picks between when adding a model by hand. */
export const MODALITY_OPTIONS = [
  { value: 'text', label: 'Text — rewriting, proofreading, extraction' },
  { value: 'vision', label: 'Vision — reading pictures and scans' },
  { value: 'multimodal', label: 'Both text and vision' },
]

/** Does a model of `have` satisfy a field or picker asking for `want`? */
export const modalityFits = (have, want) =>
  !want || have === want || (have === 'multimodal' && (want === 'text' || want === 'vision'))
